<template>
  <div class="tax-type-modal">
    <form action="" @submit.prevent="submitStructureData">
      <div class="p-8 sm:p-6">
        <sw-input-group
          :label="$t('settings.structure.name')"
          :error="nameError"
          class="mt-3"
          variant="horizontal"
          required
        >
          <sw-input
            ref="name"
            :invalid="$v.formData.name.$error"
            v-model="formData.name"
            type="text"
            @input="$v.formData.name.$touch()"
          />
        </sw-input-group>

        <sw-input-group
          :label="$t('settings.structure.invoice_code')"
          :error="sectionalCodeError"
          class="mt-3"
          variant="horizontal"
          required
        >
          <sw-input
            ref="invoice_code"
            :invalid="$v.formData.invoice_code.$error"
            v-model="formData.invoice_code"
            type="text"
            @input="$v.formData.invoice_code.$touch()"
          />
        </sw-input-group>
      </div>
      <div
        class="z-0 flex justify-end p-4 border-t border-solid border--200 border-modal-bg"
      >
        <sw-button
          class="mr-3 text-sm"
          variant="primary-outline"
          type="button"
          @click="closeStructureModal"
        >
          {{ $t('general.cancel') }}
        </sw-button>
        <sw-button :loading="isLoading" variant="primary" type="submit">
          <save-icon class="mr-2" v-if="!isLoading" />
          {{ !isEdit ? $t('general.save') : $t('general.update') }}
        </sw-button>
      </div>
    </form>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
const {
  required,
  minLength,
  between,
  maxLength,
} = require('vuelidate/lib/validators')
export default {
  data() {
    return {
      isEdit: false,
      isLoading: false,
      formData: {
        id: null,
        name: null,
        invoice_code: '',
      },
      defaultInput: {
        decimal: '.',
        thousands: ',',
        prefix: '% ',
        precision: 2,
        masked: false,
      },
    }
  },
  computed: {
    ...mapGetters('modal', [
      'modalDataID',
      'modalData',
      'modalActive',
      'refreshData',
    ]),
    sectionalCodeError() {
      if (!this.$v.formData.invoice_code.$error) {
        return ''
      }

      if (!this.$v.formData.invoice_code.maxLength) {
        return this.$t('validation.invoice_code_maxlenght')
      }
    },
    nameError() {
      if (!this.$v.formData.name.$error) {
        return '';
      }

      if (!this.$v.formData.name.required) {
        return this.$tc('validation.required')
      } else {
        return this.$tc(
          'validation.name_min_length',
          this.$v.formData.name.$params.minLength.min,
          { count: this.$v.formData.name.$params.minLength.min }
        )
      }
    },
  },
  validations: {
    formData: {
      name: {
        required,
        minLength: minLength(2),
      },
      invoice_code: {
        required,
        maxLength: maxLength(10),
      },    
    },
  },
  async mounted() {
    this.$refs.name.focus = true
    if (this.modalDataID) {
      this.isEdit = true
      this.setData()
    }
  },
  methods: {
    ...mapActions('modal', ['closeModal', 'resetModalData']),
    ...mapActions('structure', ['addStructure', 'updateStructure', 'fetchStructure']),
    resetFormData() {
      this.formData = {
        id: null,
        name: null,
        invoice_code: null,
      }
      this.$v.formData.$reset()
    },
    async submitStructureData() {
      this.$v.formData.$touch()
      if (this.$v.$invalid) {
        return true
      }
      this.isLoading = true
      let response
      if (!this.isEdit) {
        response = await this.addStructure(this.formData)
      } else {
        response = await this.updateStructure(this.formData)
      }
      if (response.data) {
        if (!this.isEdit) {
          window.toastr['success'](
            this.$t('settings.structure.created_message')
          )
        } else {
          window.toastr['success'](
            this.$t('settings.structure.updated_message')
          )
        }
        window.hub.$emit('newStructure', response.data.structure)
        this.refreshData ? this.refreshData() : ''
        this.closeStructureModal()
        this.isLoading = false
        return true
      }
      window.toastr['error'](response.data.error)
    },
    async setData() {
      this.formData = {
        id: this.modalData.id,
        name: this.modalData.name,
        invoice_code: this.modalData.invoice_code,
      }
    },
    closeStructureModal() {
      this.resetModalData()
      this.resetFormData()
      this.closeModal()
    },
  },
}
</script>
